import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../styles/about.css";

const S3 = "https://d3592s40m50m9m.cloudfront.net/about";

const GALLERY = [
  {
    id: "0198",
    src: `${S3}/DSC_0198.webp`,
    srcSmall: `${S3}/DSC_0198-800.webp`,
    alt: "Tractores cortacésped STIHL",
    ratio: 0.67,
  },
  {
    id: "0224",
    src: `${S3}/DSC_0224.webp`,
    srcSmall: `${S3}/DSC_0224-800.webp`,
    alt: "Momento STIHL",
    ratio: 0.67,
  },
  {
    id: "0214",
    src: `${S3}/DSC_0214.webp`,
    srcSmall: `${S3}/DSC_0214-800.webp`,
    alt: "Panel STIHL jardín y poda",
    ratio: 1.5,
  },
  {
    id: "0204",
    src: `${S3}/DSC_0204.webp`,
    srcSmall: `${S3}/DSC_0204-800.webp`,
    alt: "Hidrolavadoras y Sopladoras STIHL",
    ratio: 0.67,
  },
  {
    id: "0234",
    src: `${S3}/DSC_0234.webp`,
    srcSmall: `${S3}/DSC_0234-800.webp`,
    alt: "Duomo Tromen",
    ratio: 1.5,
  },
  {
    id: "0228",
    src: `${S3}/DSC_0228.webp`,
    srcSmall: `${S3}/DSC_0228-800.webp`,
    alt: "Entrada a nuestro local",
    ratio: 1.5,
  },
  {
    id: "0213",
    src: `${S3}/DSC_0213.webp`,
    srcSmall: `${S3}/DSC_0213-800.webp`,
    alt: "Exhibición motosierras STIHL",
    ratio: 1.5,
  },
  {
    id: "0232",
    src: `${S3}/DSC_0232.webp`,
    srcSmall: `${S3}/DSC_0232-800.webp`,
    alt: "Sector Tromen",
    ratio: 1.5,
  },
  {
    id: "0215",
    src: `${S3}/DSC_0215.webp`,
    srcSmall: `${S3}/DSC_0215-800.webp`,
    alt: "Motoguadañas STIHL",
    ratio: 0.67,
  },
  {
    id: "0208",
    src: `${S3}/DSC_0208.webp`,
    srcSmall: `${S3}/DSC_0208-800.webp`,
    alt: "Maquinaria profesional",
    ratio: 0.67,
  },
  {
    id: "0245",
    src: `${S3}/DSC_0245.webp`,
    srcSmall: `${S3}/DSC_0245-800.webp`,
    alt: "Accesorios Cáceres Maquinarias",
    ratio: 1.5,
  },
  {
    id: "0244",
    src: `${S3}/DSC_0244.webp`,
    srcSmall: `${S3}/DSC_0244-800.webp`,
    alt: "Repuestos y accesorios STIHL",
    ratio: 0.67,
  },
  {
    id: "0235",
    src: `${S3}/DSC_0235.webp`,
    srcSmall: `${S3}/DSC_0235-800.webp`,
    alt: "Estufas Tromen",
    ratio: 1.5,
  },
  {
    id: "0217",
    src: `${S3}/DSC_0217.webp`,
    srcSmall: `${S3}/DSC_0217-800.webp`,
    alt: "Equipos profesionales STIHL",
    ratio: 0.67,
  },
  {
    id: "0236",
    src: `${S3}/DSC_0236.webp`,
    srcSmall: `${S3}/DSC_0236-800.webp`,
    alt: "Parrilla y Accesorios Tromen",
    ratio: 0.67,
  },
  {
    id: "0199",
    src: `${S3}/DSC_0199.webp`,
    srcSmall: `${S3}/DSC_0199-800.webp`,
    alt: "Una vista a nuestros tractores cortacésped",
    ratio: 1.5,
  },
  {
    id: "0246",
    src: `${S3}/DSC_0246.webp`,
    srcSmall: `${S3}/DSC_0246-800.webp`,
    alt: "Merchandising STIHL",
    ratio: 0.67,
  },
];

const LazyImage = ({ src, alt, onClick }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="ab-masonry-item" onClick={onClick}>
      {visible ? (
        <img src={src} alt={alt} className="ab-masonry-img" loading="lazy" />
      ) : (
        <div className="ab-masonry-placeholder" />
      )}
      <div className="ab-masonry-overlay">
        <span className="ab-masonry-zoom">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 9V4h5" />
            <path d="M20 9V4h-5" />
            <path d="M4 15v5h5" />
            <path d="M20 15v5h-5" />
          </svg>
        </span>
      </div>
    </div>
  );
};

const useColumnCount = () => {
  const [cols, setCols] = useState(3);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w <= 600) setCols(2);
      else if (w <= 900) setCols(2);
      else setCols(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return cols;
};

const splitIntoColumns = (items, cols) => {
  const columns = Array.from({ length: cols }, () => []);
  const heights = Array(cols).fill(0);
  items.forEach((item, i) => {
    // elegir la columna más corta
    let minIdx = 0;
    for (let c = 1; c < cols; c++) {
      if (heights[c] < heights[minIdx]) minIdx = c;
    }
    columns[minIdx].push({ item, originalIndex: i });
    heights[minIdx] += item.ratio || 0.67;
  });
  return columns;
};

const Lightbox = ({ photo, index, total, onClose, onPrev, onNext }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose, onPrev, onNext]);

  if (!photo) return null;

  return (
    <div className="ab-lb-backdrop" onClick={onClose}>
      <button className="ab-lb-close" onClick={onClose}>
        ×
      </button>
      <button
        className="ab-lb-arrow ab-lb-prev"
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
      >
        ‹
      </button>
      <div className="ab-lb-content" onClick={(e) => e.stopPropagation()}>
        <img src={photo.src} alt={photo.alt} className="ab-lb-img" />
        <p className="ab-lb-caption">
          {photo.alt} · {index + 1} / {total}
        </p>
      </div>
      <button
        className="ab-lb-arrow ab-lb-next"
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
      >
        ›
      </button>
    </div>
  );
};

const About = () => {
  const [lightbox, setLightbox] = useState(null);
  const [historiaOpen, setHistoriaOpen] = useState(false);

  const openLightbox = (i) => setLightbox(i);
  const closeLightbox = () => setLightbox(null);
  const prevPhoto = () =>
    setLightbox((i) => (i === 0 ? GALLERY.length - 1 : i - 1));
  const nextPhoto = () =>
    setLightbox((i) => (i === GALLERY.length - 1 ? 0 : i + 1));

  const historiaPhoto = {
    src: `${S3}/DSC_0226.webp`,
    srcSmall: `${S3}/DSC_0226-800.webp`,
    alt: "Interior Cáceres Maquinarias",
  };

  useEffect(() => {
    if (!historiaOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") setHistoriaOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [historiaOpen]);

  const cols = useColumnCount();
  const columns = splitIntoColumns(GALLERY, cols);

  return (
    <div className="about-page">
      <Helmet>
        <title>Nosotros | Cáceres Maquinarias</title>
        <meta
          name="description"
          content="Desde 1977 brindando soluciones profesionales en maquinaria STIHL. Concesionario oficial en Casilda, Santa Fe."
        />
        <meta property="og:title" content="Nosotros | Cáceres Maquinarias" />
        <meta
          property="og:description"
          content="Desde 1977 brindando soluciones profesionales en maquinaria STIHL. Concesionario oficial en Casilda, Santa Fe."
        />
        <meta
          property="og:url"
          content="https://www.caceresmaquinarias.com.ar/nosotros"
        />
        <meta
          property="og:image"
          content="https://www.caceresmaquinarias.com.ar/Logo-CM.png"
        />
      </Helmet>

      <section className="ab-hero">
        <div className="ab-hero-inner">
          <div className="ab-hero-left">
            <div className="ab-hero-badge">Sobre nosotros</div>
            <h1 className="ab-hero-title">
              Construyendo confianza
              <br />
              desde <span className="ab-hero-accent">1977</span>
            </h1>
            <p className="ab-hero-sub">
              En Cáceres Maquinarias llevamos más de cuatro décadas acompañando
              a productores, empresas, comunas y clubes con soluciones
              confiables y un servicio cercano.
            </p>
          </div>
          <div className="ab-hero-stats">
            <div className="ab-stat">
              <div className="ab-stat-num">49</div>
              <div className="ab-stat-label">Años de experiencia</div>
            </div>
            <div className="ab-stat">
              <div className="ab-stat-num">20+</div>
              <div className="ab-stat-label">Marcas representadas</div>
            </div>
            <div className="ab-stat">
              <div className="ab-stat-num ab-stat-num--sm">Concesionario</div>
              <div className="ab-stat-label">Oficial STIHL</div>
            </div>
            <div className="ab-stat">
              <div className="ab-stat-num ab-stat-num--sm">Atención</div>
              <div className="ab-stat-label">Personalizada</div>
            </div>
          </div>
        </div>
      </section>

      <section className="ab-historia">
        <div className="ab-historia-inner">
          <div className="ab-historia-text">
            <div className="ab-label">Nuestra historia</div>
            <h2 className="ab-h2">Más de cuatro décadas en el rubro</h2>
            <p className="ab-p">
              Desde nuestros inicios en 1977, nos especializamos en la
              comercialización y el asesoramiento en maquinaria. A comienzos de
              los años 80 iniciamos nuestra relación con la marca STIHL,
              consolidando una trayectoria de trabajo y confianza que, con el
              tiempo, nos permitió convertirnos en concesionario oficial.
            </p>
            <p className="ab-p">
              Hoy ofrecemos maquinaria de calidad, asesoramiento personalizado y
              atención postventa, siempre con el compromiso y los valores de una
              empresa familiar que creció junto a sus clientes.
            </p>
          </div>
          <div
            className="ab-historia-photo ab-historia-photo--clickable"
            onClick={() => setHistoriaOpen(true)}
          >
            <img
              src={historiaPhoto.srcSmall}
              alt={historiaPhoto.alt}
              className="ab-historia-img"
              loading="lazy"
            />
            <div className="ab-historia-overlay">
              <span className="ab-masonry-zoom">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 9V4h5" />
                  <path d="M20 9V4h-5" />
                  <path d="M4 15v5h5" />
                  <path d="M20 15v5h-5" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="ab-galeria">
        <div className="ab-galeria-header">
          <div className="ab-label ab-label--centered">Nuestro local</div>
          <h2 className="ab-h2 ab-h2--centered">Conocé nuestro espacio</h2>
          <p className="ab-galeria-sub">
            Hacé click en cualquier foto para verla completa
          </p>
        </div>

        <div className="ab-masonry">
          {columns.map((col, colIdx) => (
            <div className="ab-masonry-col" key={colIdx}>
              {col.map(({ item, originalIndex }) => (
                <LazyImage
                  key={item.id}
                  src={item.srcSmall}
                  alt={item.alt}
                  onClick={() => openLightbox(originalIndex)}
                />
              ))}
            </div>
          ))}
        </div>
      </section>

      <section className="ab-valores">
        <div className="ab-valores-inner">
          <div className="ab-section-header">
            <div className="ab-label ab-label--centered">Cómo trabajamos</div>
            <h2 className="ab-h2 ab-h2--centered">
              Lo que nos importa de verdad
            </h2>
          </div>
          <div className="ab-valores-grid">
            <div className="ab-valor">
              <div className="ab-valor-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                  <path d="M16 8l2 2 4-4" />
                </svg>
              </div>
              <h3 className="ab-valor-title">Atención personalizada</h3>
              <p className="ab-valor-text">
                Cada cliente y cada trabajo son diferentes. Nos tomamos el
                tiempo para escuchar, asesorar y recomendar la herramienta más
                adecuada según el uso real que le vas a dar.
              </p>
            </div>
            <div className="ab-valor">
              <div className="ab-valor-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
                </svg>
              </div>
              <h3 className="ab-valor-title">Servicio y postventa</h3>
              <p className="ab-valor-text">
                Nuestro compromiso no termina con la venta. Contamos con
                repuestos originales y el respaldo necesario para mantener tus
                equipos en óptimas condiciones.
              </p>
            </div>
            <div className="ab-valor">
              <div className="ab-valor-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </div>
              <h3 className="ab-valor-title">Marcas de confianza</h3>
              <p className="ab-valor-text">
                Solo trabajamos con marcas que respaldamos. STIHL, Bosch, Tromen
                y otras primeras marcas que conocemos a fondo porque llevamos
                décadas con ellas.
              </p>
            </div>
            <div className="ab-valor">
              <div className="ab-valor-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                </svg>
              </div>
              <h3 className="ab-valor-title">Conocimiento real</h3>
              <p className="ab-valor-text">
                No somos improvisados. Conocemos cada máquina que vendemos
                porque hace décadas que estamos en esto. Compartimos nuestra
                experiencia para que tomes una buena decisión.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ab-pilares">
        <div className="ab-pilares-inner">
          <div className="ab-section-header">
            <div className="ab-label ab-label--centered ab-label--light">
              Nuestros pilares
            </div>
            <h2 className="ab-h2 ab-h2--centered ab-h2--light">
              Por qué elegirnos
            </h2>
          </div>
          <div className="ab-pilares-grid">
            <div className="ab-pilar">
              <div className="ab-pilar-num">01</div>
              <h4 className="ab-pilar-title">Estamos con vos</h4>
              <p className="ab-pilar-text">
                No solo vendemos, te asesoramos. Te acompañamos desde la primera
                duda hasta que el trabajo queda listo.
              </p>
            </div>
            <div className="ab-pilar">
              <div className="ab-pilar-num">02</div>
              <h4 className="ab-pilar-title">Sabemos del tema</h4>
              <p className="ab-pilar-text">
                No somos improvisados. Conocemos cada máquina que vendemos
                porque hace años que estamos en esto.
              </p>
            </div>
            <div className="ab-pilar">
              <div className="ab-pilar-num">03</div>
              <h4 className="ab-pilar-title">Hacemos las cosas bien</h4>
              <p className="ab-pilar-text">
                Ofrecemos productos de primera línea y un servicio que supera
                las expectativas, garantizando resultados profesionales.
              </p>
            </div>
            <div className="ab-pilar">
              <div className="ab-pilar-num">04</div>
              <h4 className="ab-pilar-title">Repuestos originales</h4>
              <p className="ab-pilar-text">
                Contamos con repuestos legítimos de las marcas que trabajamos
                para asegurar la vida útil de tu inversión.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ab-cta">
        <div className="ab-cta-inner">
          <h2 className="ab-cta-title">
            Potenciá tu trabajo con herramientas profesionales
          </h2>
          <p className="ab-cta-sub">
            Descubrí nuestra amplia gama de productos y soluciones para cada
            necesidad
          </p>
          <div className="ab-cta-buttons">
            <Link to="/productos" className="ab-btn ab-btn--white">
              Ver productos
            </Link>
            <Link to="/contacto" className="ab-btn ab-btn--outline">
              Contactanos
            </Link>
          </div>
        </div>
      </section>

      <Lightbox
        photo={lightbox !== null ? GALLERY[lightbox] : null}
        index={lightbox}
        total={GALLERY.length}
        onClose={closeLightbox}
        onPrev={prevPhoto}
        onNext={nextPhoto}
      />

      {historiaOpen && (
        <div className="ab-lb-backdrop" onClick={() => setHistoriaOpen(false)}>
          <button
            className="ab-lb-close"
            onClick={() => setHistoriaOpen(false)}
          >
            ×
          </button>
          <div className="ab-lb-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={historiaPhoto.src}
              alt={historiaPhoto.alt}
              className="ab-lb-img"
            />
            <p className="ab-lb-caption">{historiaPhoto.alt}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;
